import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { guaranteeItems } from '../../data/content';
export function Guarantee() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="guarantee-title" data-id="element-201" data-mp="24moqj74jg2mf">
      <div className="mx-auto max-w-4xl" data-id="element-202" data-mp="29egfxebyk2az">
        <div className="rounded-3xl bg-success-soft p-6 ring-1 ring-success/20 sm:p-10" data-id="element-203" data-mp="29fhq7gl5gkrn">
          <div className="flex flex-col items-center text-center" data-id="element-204" data-mp="2ec87u8clrof6">
            <span className="relative flex h-28 w-28 items-center justify-center rounded-full bg-success text-white" data-id="element-205" data-mp="2jbl39hhji3td">
              <ShieldCheckIcon className="h-14 w-14" strokeWidth={1.75} aria-hidden="true" data-id="element-206" data-mp="2oc8vg6hi8qp6" />
              <span className="absolute -bottom-2 rounded-full bg-navy-950 px-3 py-1 text-xs font-black uppercase text-cta" data-id="element-207" data-mp="2sd2eomk05hbq">
                7 days
              </span>
            </span>
            <h2 id="guarantee-title" className="mt-6 text-[28px] font-black leading-[1.1] tracking-tight text-ink text-balance sm:text-4xl" data-id="element-208" data-mp="xy8a9418cav3">
              Your 7-day satisfaction guarantee
            </h2>
            <p className="mt-3 text-lg font-bold text-success" data-id="element-209" data-mp="3ntf3ebny6ggt">
              Review the Blueprint™ and decide if it meets your expectations
            </p>
          </div>

          <div className="mx-auto mt-6 max-w-2xl space-y-4 text-base leading-relaxed text-ink" data-id="element-210" data-mp="3dxljg77wfkp0">
            <p data-id="element-211" data-mp="fdvd9likpe5z">I want you to understand exactly what you’re getting when you purchase my educational collection.</p>
            <p data-id="element-212" data-mp="agd1zoh32mut">
              If the published seven-day refund policy applies to your purchase, you’ll have seven days to review the
              material and decide whether it meets the expectations described on this page. During that time, you can
              explore:
            </p>
          </div>

          <ul className="mx-auto mt-5 grid max-w-2xl gap-2.5 sm:grid-cols-2" data-id="element-213" data-mp="2q89a97ckncmp">
            {guaranteeItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-214" data-mp="2la7qek7bn9a6">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-success text-white" data-id="element-215" data-mp="1d8xmd01eeazq">
                  <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-216" data-mp="1h7om7ex906qj" />
                </span>
                <span className="text-[15px] font-semibold text-ink" data-id="element-217" data-mp="189cqwzlfskrr">{item}</span>
              </li>)}
          </ul>

          <div className="mx-auto mt-6 max-w-2xl space-y-4 text-base leading-relaxed text-ink" data-id="element-218" data-mp="tk6u1ia2n6n1">
            <p data-id="element-219" data-mp="ybeydzwjo1tc">
              If the product doesn’t meet the expectations described in the offer, you can request a refund within the
              applicable seven-day period under the published refund terms.
            </p>
            <p className="font-bold" data-id="element-220" data-mp="pjd1gblop3nt">
              My goal is to provide an organized educational resource that delivers the value you expect.
            </p>
          </div>
        </div>

        <SectionCTA label="Get the Blueprint™ with the 7-day guarantee" data-id="element-221" data-mp="fjchcnfzqjik" />
      </div>
    </section>;
}